import { createFeatureSelector, createSelector } from '@ngrx/store';

import { digitalCourseAdapter } from './digital-course.entity';
import { DigitalCourseState, digitalCourseFeatureKey } from './digital-course.state';

export const { selectAll, selectEntities, selectIds, selectTotal } = digitalCourseAdapter.getSelectors();

export const getDigitalCourseState = createFeatureSelector<DigitalCourseState>(digitalCourseFeatureKey);

export const getAllDigitalCourses = createSelector(getDigitalCourseState, selectAll);

export const getDigitalCourseById = (id: string) =>
  createSelector(getDigitalCourseState, (state) => state.entities[id]);
export const getDigitalCourseBySlug = (slug: string) =>
  createSelector(getAllDigitalCourses, (state) => {
    return state.find((course) => course.courseSlug === slug);
    /*for (const [key, value] of Object.entries(state.entities)) {
    if(value.courseSlug === slug) return state.entities[key];
  }*/
  });

export const getSelectedDigitalCourse = createSelector(
  getDigitalCourseState,
  (state) => state.entities[state.selectedDigitalCourseId]
);
export const getDigitalCourseId = createSelector(getDigitalCourseState, (state) => state.selectedDigitalCourseId);
export const getAdvantages = createSelector(getDigitalCourseState, (state) => state.advantages);
export const getQuestions = createSelector(getDigitalCourseState, (state) => state.questions);

export const getError = createSelector(getDigitalCourseState, (state) => state.error);

export const getFilter = createSelector(getDigitalCourseState, (state) => state.filter);

export const getTotalCount = createSelector(getDigitalCourseState, (state) => state.totalCount);
